import { lazy, Suspense } from 'react';

import { useFormState } from 'react-hook-form';

import appConfig from '@config';
import { Box, Skeleton, Button, Group, Stack } from '@ui';

import { AdaptiveFormRows } from './AdaptiveFormRows';
import classes from './styles/AdaptiveForm.module.css';
import { AdaptiveFormConfig, AdaptiveFormProps } from './types';

const QAAssistPanelWrapper: React.ComponentType<{ formConfig: AdaptiveFormConfig }> =
  appConfig.IS_PROD
    ? () => null
    : lazy(() =>
        import('./qa-assist/QAAssistPanel').then((m) => ({
          default: m.QAAssistPanelWrapper
        }))
      );

/*
A component that renders form by configuration.
Uses react-hook-forms underneath.
*/
const AdaptiveForm = ({
  config,
  loading,
  submitButtonText = 'Next'
}: AdaptiveFormProps) => {
  const { isSubmitting } = useFormState();

  return (
    <Stack gap={24}>
      {loading ? (
        <Skeleton height={400} />
      ) : (
        <Box component="fieldset" className={classes.fieldSet}>
          {/* gap prop here controls the space between rows */}
          <AdaptiveFormRows config={config} />
        </Box>
      )}
      <Suspense fallback={null}>
        <QAAssistPanelWrapper formConfig={config} />
      </Suspense>
      <Group justify="flex-end" align="center">
        <Button
          size="xl"
          type="submit"
          loading={loading || isSubmitting}
          color="primary"
        >
          {submitButtonText}
        </Button>
      </Group>
    </Stack>
  );
};

export { AdaptiveForm };
